import { useEffect, useState } from 'react';

import { useModal } from 'context/ModalContext';
import { ConfirmacaoDaAcao } from 'components/task-item/modal-actions/moldura-da-acao';

interface Props {
  callback: (obj: { id: string }) => void;
}

/** Confirmação de exclusão do cartão antigo (`confirm-delete`), com "Ação ECOA" no título (ECN-57). */
export default function ModalConfirm(props: Props) {
  const modalID = 'confirm-delete';

  const { openModal, modalData, closeModal } = useModal();
  const { callback } = props;

  const [modalIsOpen, setIsOpen] = useState<boolean>(false);

  useEffect(() => {
    if (typeof openModal === 'string' && openModal === modalID) {
      setIsOpen(true);
    } else {
      setIsOpen(false);
    }
  }, [openModal]);

  if (!modalIsOpen) return <></>;

  return (
    <ConfirmacaoDaAcao
      title="Deseja mesmo excluir essa Ação ECOA?"
      onClose={() => closeModal()}
      onConfirm={() => {
        callback({ id: modalData.id });
        closeModal();
      }}
    />
  );
}
